<!-- Body -->
<div class="ui basic segment" [class.loading]="isLoading">
    <app-header [title]="title" [back]="true"></app-header>
    <div class="ui layout">
        <div class="content">
            <div class="ui segment">
                <app-form-applicant-message-template
                    [applicantMessageTemplate]="applicantMessageTemplate"
                    #applicantMessageTemplateForm
                ></app-form-applicant-message-template>
                <div style="display: flex; justify-content: flex-end">
                    <ui-button type="primary" (click)="onSave(applicantMessageTemplateForm)">{{
                        'save' | translate
                    }}</ui-button>
                </div>
            </div>
        </div>

        <div class="sidebar">
            <app-customization-tokens></app-customization-tokens>
        </div>
    </div>
</div>
